// extracted by mini-css-extract-plugin
export default {"pickerWrapper":"color_pickerWrapper__R5wox","label":"color_label__eFgga"};